// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#9-schema-level-empty-data-detection
// v.check on data array raises @WARNING when backend returns zero surgeons.
import * as v from 'valibot';

import { surgeonSchema } from '#entities/schemas';

export const surgeonsResponseSchema = v.object({
  /** Array of surgeons */
  data: v.pipe(
    v.array(surgeonSchema),
    v.check(
      arr => arr.length > 0,
      '@WARNING: No surgeons returned — backend may be unavailable or data is stale',
    ),
  ),
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type SurgeonsResponse = v.InferInput<typeof surgeonsResponseSchema>;
